export default __webpack_public_path__ + "static/media/diameter.9eeb2e75.svg";